// Etiqueta de la fuente de un viaje, compartida por la lista de Viajes y el
// dashboard (DEF-ADM-027 / DEF-ADM-028).
//
// La BD guarda fuente y segmento por separado; la etiqueta compuesta es solo
// presentación y la arma el frontend. Vive acá y no en una pantalla porque la
// usan dos: copiarla es como nacieron los mapeos paralelos que ya costaron un
// bug en este proyecto.

// Solo los clientes directos llevan etiqueta compuesta. Una OTA o un afiliado
// muestran su nombre tal cual, y su tipo_pasajero es NULL en la BD.
export function fuenteLabel(fuente, tipoPasajero) {
  if (!fuente) return "";
  if (fuente !== "DIRECTO") return fuente;
  const seg = (tipoPasajero || "").toUpperCase();
  return seg === "FRECUENTE" || seg === "VIP" ? `CLIENTE ${seg}` : "CLIENTE DIRECTO";
}

// Conveniencia para cuando se tiene el objeto del viaje entero.
export function fuenteLabelDeViaje(ride) {
  if (!ride) return "";
  return fuenteLabel(ride.fuente, ride.tipo_pasajero);
}

// Clase CSS del badge. Baja a minúsculas y saca lo que no sea alfanumérico, así
// que "Despegar" y "DESPEGAR" comparten color.
export function fuenteBadgeClass(fuente) {
  if (!fuente) return "default";
  return fuente.toLowerCase().replace(/[^a-z0-9]/g, "");
}
